import React from "react";
import { Checkbox } from 'antd';

import { RegistorClass } from "../core/ComponentRegistor";
const CheckboxGroup = Checkbox.Group;
const plainOptions = ['Apple', 'Pear', 'Orange', 'Bonana'];
const defaultCheckedList = ['Apple', 'Orange'];
export class AntCheckbox extends React.Component<any> {
    state = {
        checkedList: defaultCheckedList,
        indeterminate: true,
        checkAll: false,
    }
    onChange = checkedList => {
        this.setState({
            checkedList,
            indeterminate: !!checkedList.length && checkedList.length < plainOptions.length,
            checkAll: checkedList.length === plainOptions.length,
        });
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        var disabled = (this.props.disabled == undefined) ? false : (this.props.disabled[0] == '禁止选择') ? true : false
        return (
            <div>
                <div style={{ borderBottom: '1px solid #E9E9E9' }}>
                </div>
                {getFieldDecorator(this.props.formKey, {
                    rules: [{
                        validator: this.props.validator
                    }, {
                        required: this.props.required, message: '必填项!',
                    }],
                })(
                    <CheckboxGroup
                        options={(this.props.list) ? this.props.list : plainOptions}
                        disabled={disabled}
                        value={this.state.checkedList}
                        onChange={this.onChange}
                    />)}
            </div>
        );

    }
    handleSizeChange = e => {
        this.setState({ size: e.target.value });
    };
}

let scheme = {
    key: "test",
    name: "testName",
    props: {},
    children: [
        {
            class: {
                componentTag: "AntInput",
            },
            key: "span",
            name: "占位数",
            props: {
                // span: 6,
                required: true,
                label: "占位数"
            }
        },
        {
            class: {
                componentTag: "AntInput",
            },
            key: "label",
            name: "显示名",
            props: {
                // span: 6,
                label: "显示名"
            }
        },
        {
            class: {
                componentTag: "Ant-CheckboxContainer",
            },
            key: "disabled",
            name: "禁止选择(是或否）",
            props: {
                // span: 6,
                label: "禁止选择(是或否）"
            }
        }
    ]
}
RegistorClass({
    componentTag: "Ant-Checkbox",
    componentObject: AntCheckbox,
    componentName: "Ant多选框",
    scheme: scheme,
    defaultProps: {
        span: 24,
        lable: "多选框",
        required: false
    }
})
// export default AntTextarea